import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import StoreDetailModal from '../../Appointments/components/StoreDetailModal/StoreDetailModal.js';
import PrescriptionTable from '../../Prescriptions/components/PrescriptionTable/PrescriptionTable.js';
import { useAddressFormSlotsContext } from '../../slots/AddressFormSlotsContext.js';
import { useStoreAddressFormSlotsContext } from '../../slots/StoreAddressFormSlotsContext.js';
import DetailFooterContainer from '../components/Footer/DetailFooter/DetailFooterContainer.js';
import Order from '../components/Order/Order.js';
import { GlassesPrescription } from './OrderDetailCard/GlassesPrescription.js';
import OrderDetailCard from './OrderDetailCard/OrderDetailCard.js';
import { isContactLensesOrderLineItem, isGlassesBundleOrderLineItem } from '../models/line-items.js';
import { DeliveryMethod } from '../models/details-order.js';

const OrderDetail = ({ labels , onCloseStoreDetailModal , onOpenStoreDetailModal , onTraceOrder , onReorder , onOpenCancelReturnsModal , onCloseCancelReturnsModal , onDownloadReceiptClick , isCancelReturnsModalOpen , detail , isModalOpen , storeName , intl , prescriptionsUrl , isReorderAvailable , isPaid ,  })=>{
    var ref, ref1;
    const { Slots: { summary: AddressSummaryTemplate  } ,  } = useAddressFormSlotsContext();
    const { Slots: { summary: StoreAddressSummaryTemplate  } ,  } = useStoreAddressFormSlotsContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-detail"
    }, /*#__PURE__*/ React.createElement(Order, {
        className: "order-details__order",
        onReorder: isReorderAvailable ? onReorder : undefined,
        shipmentTrackingUrl: detail.shipmentTrackingUrl,
        footer: /*#__PURE__*/ React.createElement(DetailFooterContainer, {
            subtotal: detail.subtotalAmount,
            discount: detail.discountedAmount,
            shippingCost: detail.shippingMethodPrice,
            total: detail.totalPrice
        }),
        orderDate: detail.orderDate,
        orderNumber: detail.orderNumber,
        shipmentStatus: detail.shipmentStatus,
        receiptUrl: detail.receiptUrl,
        paymentStatus: detail.paymentStatus,
        onTraceOrder: onTraceOrder,
        onOpenCancelReturnsModal: onOpenCancelReturnsModal,
        onCloseCancelReturnsModal: onCloseCancelReturnsModal,
        onDownloadReceiptClick: onDownloadReceiptClick,
        isCancelReturnsModalOpen: isCancelReturnsModalOpen,
        isPaid: isPaid
    }, detail === null || detail === void 0 ? void 0 : (ref = detail.lineItems) === null || ref === void 0 ? void 0 : ref.map((item, i)=>{
        const baseProps = {
            currency: intl.currency,
            discountPrice: item.lineItemDiscountedPrice,
            imagePath: item.productImage,
            isReorderAvailable: item.isReorderAvailable,
            labels,
            lineItemId: item.lineItemId,
            onReorder,
            price: item.lineItemOriginalPrice,
            quantity: item.productQuantity,
            subtitle: item.subtitle,
            title: item.title
        };
        if (isContactLensesOrderLineItem(item)) {
            return /*#__PURE__*/ React.createElement(OrderDetailCard, swcHelpers.extends({
                key: `${item.productSku}-${i}`,
                footerType: "reorder"
            }, baseProps), item.prescription ? /*#__PURE__*/ React.createElement(OrderDetailCard.PrescriptionSection, {
                labels: labels
            }, /*#__PURE__*/ React.createElement(PrescriptionTable, {
                size: "narrow",
                orientation: "eyeSideTop",
                className: "order-detail-card__prescription-table",
                /**
                       * Since the CL prescription has more specific object keys, it cannot be
                       * directly assigned to less specific object keys.
                       * Source: https://stackoverflow.com/a/37006179
                       */ prescription: swcHelpers.objectSpread({}, item.prescription)
            })) : null);
        }
        if (isGlassesBundleOrderLineItem(item)) {
            return /*#__PURE__*/ React.createElement(OrderDetailCard, swcHelpers.extends({
                key: `${item.productSku}-${i}`,
                bundleChildLineItems: item.bundleChildLineItems,
                bundleConfiguration: item.bundleConfiguration,
                configurationType: "glasses"
            }, baseProps), item.prescription ? /*#__PURE__*/ React.createElement(OrderDetailCard.PrescriptionSection, {
                labels: baseProps.labels
            }, /*#__PURE__*/ React.createElement(GlassesPrescription, {
                intl: intl,
                prescription: item.prescription,
                prescriptionsUrl: prescriptionsUrl
            })) : null);
        }
        return /*#__PURE__*/ React.createElement(OrderDetailCard, swcHelpers.extends({
            key: `${item.productSku}-${i}`
        }, baseProps, {
            footerType: "reorder"
        }), item.prescription ? /*#__PURE__*/ React.createElement(OrderDetailCard.PrescriptionSection, {
            labels: baseProps.labels
        }, /*#__PURE__*/ React.createElement(PrescriptionTable, {
            size: "narrow",
            orientation: "eyeSideTop",
            className: "order-detail-card__prescription-table",
            /**
                     * Since the CL prescription has more specific object keys, it cannot be
                     * directly assigned to less specific object keys.
                     * Source: https://stackoverflow.com/a/37006179
                     */ prescription: {
                rightEye: swcHelpers.objectSpread({}, item.prescription.rightEye),
                leftEye: swcHelpers.objectSpread({}, item.prescription.leftEye)
            }
        })) : null);
    })), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__info"
    }, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "smallest"
    }, labels.orderDetails)), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.shipmentMethodTitle), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, null, labels.makeDeliveryMethodName(detail === null || detail === void 0 ? void 0 : detail.deliveryMethod)), (detail === null || detail === void 0 ? void 0 : detail.deliveryMethod) === DeliveryMethod.PickUp && /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Link, {
        iconAfter: "chevron-right",
        onClick: onOpenStoreDetailModal
    }, labels.storeInfo))))), /*#__PURE__*/ React.createElement(Card.Section, null, (detail === null || detail === void 0 ? void 0 : (ref1 = detail.shippingAddress) === null || ref1 === void 0 ? void 0 : ref1.externalId) && isModalOpen && /*#__PURE__*/ React.createElement(StoreDetailModal, {
        storeCode: detail.shippingAddress.externalId,
        onModalClose: onCloseStoreDetailModal
    }), /*#__PURE__*/ React.createElement(Card.Section, {
        flex: true,
        className: "order-details__items"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__detail",
        spacing: "none"
    }, detail.shippingAddress && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.shipmentAddress), (detail === null || detail === void 0 ? void 0 : detail.deliveryMethod) === DeliveryMethod.PickUp && StoreAddressSummaryTemplate ? /*#__PURE__*/ React.createElement(StoreAddressSummaryTemplate, {
        storeName: storeName,
        values: swcHelpers.objectSpread({}, detail.shippingAddress)
    }) : null, (detail === null || detail === void 0 ? void 0 : detail.deliveryMethod) !== DeliveryMethod.PickUp && AddressSummaryTemplate ? /*#__PURE__*/ React.createElement(AddressSummaryTemplate, {
        values: swcHelpers.objectSpread({}, detail.shippingAddress)
    }) : null)), detail.billingAddress && /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__detail",
        spacing: "none"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.billingAddress), AddressSummaryTemplate ? /*#__PURE__*/ React.createElement(AddressSummaryTemplate, {
        values: swcHelpers.objectSpread({}, detail.billingAddress)
    }) : null)), /*#__PURE__*/ React.createElement(Card.Section, null, detail.paymentMethod && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.paymentMethod), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, null, detail.paymentMethod)))))));
};
var OrderDetail$1 = OrderDetail;

export { OrderDetail$1 as default };
//# sourceMappingURL=OrderDetail.js.map
